import React, { useEffect, useState } from 'react';
import DashboardLayout from "../layout/index";
import axios from 'axios';
import { toast } from "react-toastify";
import { Switch } from 'antd';
import { useNavigate } from 'react-router-dom';

const ReceptionistList = () => {
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;
    const [receptionists, setReceptionists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [updatingId, setUpdatingId] = useState(null);
    const [selectedReceptionist, setSelectedReceptionist] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        fetchList();
    }, []);

    const fetchList = async () => {
        const token = localStorage.getItem("auth_token");
        const tenantId = localStorage.getItem("tenantId");

        try {
            const res = await fetch(
                `${API_URL}auth/clinic-user-details/${tenantId}?role=USER`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                        // tenantId: tenantId,
                    },
                }
            );
            const data = await res.json();
            setReceptionists(data);
            setLoading(false);
        } catch (error) {
            console.error("Failed to fetch receptionist data:", error);
            toast.error("Failed to fetch receptionist data");
            setLoading(false);
        }
    };

    const handleToggleStatus = async (receptionist) => {
        console.log(receptionist,"cfghvjk")
        if (!receptionist?.id) return;
        const token = localStorage.getItem("auth_token");
        const tenantId = localStorage.getItem("tenantId");
        const API_BASE = process.env.REACT_APP_API_URL;
        const nextActive = !(receptionist.active === true);
        try {
            setUpdatingId(receptionist.userId);
            
            // First call with tenantId
            const res1 = await fetch(`${API_BASE}auth/update-user-details/${receptionist.userId}`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                    tenantId: tenantId,
                },
                body: JSON.stringify({ active: nextActive })
            });
            
            if (res1.ok) {
                // Second call without tenantId
                const res2 = await fetch(`${API_BASE}auth/update-user-details/${receptionist.userId}`, {
                    method: "PUT",
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ active: nextActive })
                });
                
                if (res2.ok) {
                    setReceptionists(prev => (prev || []).map(r => r.id === receptionist.id ? { ...r, active: nextActive } : r));
                    toast.success(`User ${nextActive ? 'activated' : 'deactivated'}`);
                } else {
                    throw new Error('Second API call failed');
                }
            } else {
                throw new Error('First API call failed');
            }
        } catch (e) {
            console.error(e);
            toast.error('Unable to update user status');
        } finally {
            setUpdatingId(null);
        }
    };

    const handleViewDetails = (receptionist) => {
        setSelectedReceptionist(receptionist);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedReceptionist(null);
    };

    const formatQualifications = (qualifications) => {
        if (!qualifications || qualifications.length === 0) return '-';
        return qualifications.join(', ');
    };

    const formatSpecialization = (specialization) => {
        if (!specialization || specialization.length === 0) return '-';
        return specialization.join(', ');
    };

    if (loading) {
        return (
            <DashboardLayout>
                <div className="mt-6 flex justify-center items-center h-64">
                    <div className="text-lg text-[#004276]">Loading receptionists...</div>
                </div>
            </DashboardLayout>
        );
    }
    const handleEditReceptionist = (receptionist) => {
        navigate('/clinicStaffEdit', { 
            state: { 
                receptionistData: receptionist,
                isEdit: true 
            }
        });
    };
    return (
        <DashboardLayout>
            <div className="mt-6">
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6">
                    <h3 className="text-lg font-semibold text-[#004276]">
                        Receptionist List
                    </h3>
                </div>

                {/* Receptionist Table */}
                <div className="bg-white rounded-lg shadow-md overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        First Name
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Middle Name
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Last Name
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Mobile Number
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Role
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Email Id
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Status
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {receptionists.map((receptionist) => (
                                    <tr key={receptionist.id} className="hover:bg-gray-50">
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm font-medium text-gray-900">
                                                {receptionist.firstName}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm font-medium text-gray-900">
                                                {receptionist.middleName}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                {receptionist.lastName}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="text-sm text-gray-900 max-w-xs">
                                                {/* <div className="flex flex-wrap gap-1"> */}
                                                {receptionist.mobile}

                                                {/* </div> */}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                {Array.isArray(receptionist.roles)
                                                    ? receptionist.roles.join(", ")
                                                    : receptionist.roles}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                {receptionist.email}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="flex items-center gap-3">
                                                <span className={`inline-flex items-center gap-2 text-sm font-medium ${receptionist.active ? 'text-green-600' : 'text-red-600'}`}>
                                                    {/* <span className={`w-2 h-2 rounded-full ${receptionist.active ? 'bg-green-500' : 'bg-red-500'}`}></span> */}
                                                    {receptionist.active ? 'Active' : 'Inactive'}
                                                </span>
                                                <Switch
                                                    checked={!!receptionist.active}
                                                    loading={updatingId === receptionist.id}
                                                    onChange={() => handleToggleStatus(receptionist)}
                                                    size="small"
                                                />
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 flex gap-2 whitespace-nowrap text-sm font-medium">
                                            <div className="flex gap-2">
                                            <button
                                                onClick={() => handleViewDetails(receptionist)}
                                                className="rounded-full bg-gradient-to-r from-[#004172] to-[#3cba84] text-white px-4 py-2 rounded-md text-sm transition-colors duration-200"
                                            >
                                                View 
                                            </button>
                                            <button
                                              
                                                onClick={() => handleEditReceptionist(receptionist)}
                                                className="rounded-full bg-gradient-to-r from-[#004172] to-[#3cba84] text-white px-4 py-2 rounded-md text-sm transition-colors duration-200"
                                            >
                                                Edit 
                                            </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Modal for Bank Details and Slot Details */}
                {showModal && selectedReceptionist && (
                    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
                        <div className="relative top-20 mx-auto p-5 border w-11/12 md:w-3/4 lg:w-1/2 shadow-lg rounded-md bg-white">
                            <div className="mt-3">
                                <div className="flex justify-between items-center mb-4">
                                    <h3 className="text-lg font-medium text-gray-900">
                                        Receptionist Details - {selectedReceptionist.firstName}
                                    </h3>
                                    <button
                                        onClick={closeModal}
                                        className="text-gray-400 hover:text-gray-600 text-xl font-bold"
                                    >
                                        ×
                                    </button>
                                </div>

                                <div className="mb-6">
                                    <h4 className="text-md font-semibold text-[#004276] mb-3 border-b pb-2">
                                        Info
                                    </h4>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">Full Name</label>
                                            <p className="text-sm text-gray-900">{`${selectedReceptionist.firstName || ''} ${selectedReceptionist.middleName || ''} ${selectedReceptionist.lastName || ''}`.trim()}</p>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">Mobile Number</label>
                                            <p className="text-sm text-gray-900">{selectedReceptionist.mobile || '-'}</p>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">Email</label>
                                            <p className="text-sm text-gray-900">{selectedReceptionist.email || '-'}</p>
                                        </div>
                                        {/* <div>
                                            <label className="block text-sm font-medium text-gray-700">Role</label>
                                            <p className="text-sm text-gray-900">{selectedReceptionist.role || '-'}</p>
                                        </div> */}
                                    </div>
                                </div>


                                <div className="mt-6 flex justify-end">
                                    <button
                                        onClick={closeModal}
                                        className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md text-sm transition-colors duration-200"
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </DashboardLayout>
    );
};

export default ReceptionistList;